export default "__VITE_ASSET__b3dac518__"